<h4 class="page-title">
  <i class="fas fa-map-marked-alt"></i>
  Mapa de Entregas
</h4>

<div class="card">
  <div class="card-box">
    <kendo-panelbar class="mb-0 pb-0" style="border-bottom: 0;">
      <kendo-panelbar-item [title]="'Filtros'" [expanded]="true">
        <ng-template kendoPanelBarContent>
          <div class="card card-body pt-2 pb-0">
            <div class="row filtro">
              <div class="col-md-auto" *ngIf="!periodoEspecifico">
                <label>
                  <span class="label lh">Mês <br></span>
                  <kendo-datepicker style="width: 20em" class="form-control"
                                    [bottomView]="'year'"
                                    [topView]="'year'"
                                    [format]="'MMMM yyyy'"
                                    [activeView]="'year'"
                                    [max]="hoje"
                                    (valueChange)="mudouValorMes($event)"
                                    [(value)]="valorMes">
                  </kendo-datepicker>

                  <p class="text-blue cpointer mt-2" (click)="exibirPeriodoEspecifico()">
                    Período especifico</p>
                </label>
              </div>

              <div class="col-md-auto" *ngIf="periodoEspecifico">
                <kendo-daterange class="mr-2">
                  <label>
                    <span class="label lh">De <br></span>
                    <kendo-datetimepicker style="width: 16em" [ngModel]="filtro.inicio" [max]="hoje" (ngModelChange)="mudouInicio($event)">
                      <kendo-datetimepicker-messages
                        today="Hoje"
                        toggle="Alterar data"
                        cancel="Cancelar"
                        dateTab="Data"
                        timeTab="Hora"
                        now="Agora"
                        accept="Ok"
                      ></kendo-datetimepicker-messages>
                    </kendo-datetimepicker>
                  </label>
                  <label class="ml-2">
                    <span class="label lh">Até </span><br>
                    <kendo-datetimepicker style="width: 16em" [ngModel]="filtro.fim" [min]="filtro.inicio" [max]="maxFim" (ngModelChange)="mudouFim($event)">
                      <kendo-datetimepicker-messages
                        today="Hoje"
                        toggle="Alterar data"
                        cancel="Cancelar"
                        dateTab="Data"
                        timeTab="Hora"
                        now="Agora"
                        accept="Ok"
                      ></kendo-datetimepicker-messages>
                    </kendo-datetimepicker>
                  </label>
                  <p class="text-blue cpointer" (click)="exibirPeriodoMensal()">
                    Período mensal</p>
                </kendo-daterange>
                <small class="text-muted d-block mt-1">Período máximo de 31 dias por análise.</small>
              </div>

              <div class="col-3" *ngIf="entregadores.length > 1">
                <label class="w-100">
                  <span class="label lh">Por entregador <br></span>
                  <kendo-dropdownlist [filterable]="true" name="entregador" [ngModel]="filtro.entregador"
                                      (ngModelChange)="mudouEntregador($event)"
                                      (filterChange)="busqueEntregadores($event)" [data]="entregadores" textField="nome"
                                      class="form-control">
                  </kendo-dropdownlist>
                </label>
              </div>
            </div>
            <div class="alert alert-info py-2 mb-2" *ngIf="avisoPeriodo">
              <i class="fe-info"></i> {{ avisoPeriodo }}
            </div>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>

    <div class="analise-pedidos">
      <div class="text-center p-4" *ngIf="carregandoDesempenho && !desempenhoEntregas">
        <i class="k-icon k-i-loading"></i>
        Carregando análise
      </div>

      <div class="alert alert-danger" *ngIf="erroDesempenho && !carregandoDesempenho">
        <i class="fe-alert-triangle"></i>
        {{erroDesempenho}}
      </div>

      <ng-container *ngIf="desempenhoEntregas">
        <div class="alert alert-info aviso-localizacao aviso-localizacao-estimada" *ngIf="usaMapaAproximado()">
          <i class="fe-info"></i>
          Mapa aproximado: pedidos sem localização foram posicionados por endereço ou bairro.
        </div>

        <div class="alert alert-warning aviso-localizacao" *ngIf="desempenhoEntregas.localizacao?.semLocalizacao > 0">
          <i class="fe-alert-triangle"></i>
          {{desempenhoEntregas.localizacao.semLocalizacao}} pedido(s) sem localização suficiente neste período.
          Para entregas por bairro, veja o resumo por bairro e a origem dos pedidos.
        </div>

        <div class="row indicadores-pedido">
          <div class="col-md-2 col-sm-4">
            <div class="indicador-pedido">
              <span>Pedidos</span>
              <strong>{{desempenhoEntregas.indicadores?.quantidadeEntregas || 0}}</strong>
            </div>
          </div>
          <div class="col-md-2 col-sm-4">
            <div class="indicador-pedido">
              <span>No mapa</span>
              <strong>{{desempenhoEntregas.indicadores?.entregasNoMapa || 0}}</strong>
            </div>
          </div>
          <div class="col-md-2 col-sm-4">
            <div class="indicador-pedido">
              <span>Sem localização</span>
              <strong>{{desempenhoEntregas.indicadores?.entregasSemLocalizacao || 0}}</strong>
            </div>
          </div>
          <div class="col-md-2 col-sm-4">
            <div class="indicador-pedido">
              <span>Duração média</span>
              <strong>{{formateMinutos(desempenhoEntregas.indicadores?.duracaoMediaMinutos)}}</strong>
            </div>
          </div>
          <div class="col-md-2 col-sm-4">
            <div class="indicador-pedido">
              <span>No prazo</span>
              <strong>{{formatePercentual(desempenhoEntregas.indicadores?.percentualNoPrazo)}}</strong>
            </div>
          </div>
          <div class="col-md-2 col-sm-4">
            <div class="indicador-pedido">
              <span>Atrasados</span>
              <strong>{{desempenhoEntregas.indicadores?.entregasAtrasadas || 0}}</strong>
            </div>
          </div>
        </div>

        <div class="metricas-tempo">
          <div>
            <span>Confirmar</span>
            <strong>{{formateMinutos(desempenhoEntregas.metricasTempo?.tempoConfirmacaoMinutos)}}</strong>
          </div>
          <div>
            <span>Preparo</span>
            <strong>{{formateMinutos(desempenhoEntregas.metricasTempo?.tempoPreparoMinutos)}}</strong>
          </div>
          <div>
            <span>Espera</span>
            <strong>{{formateMinutos(desempenhoEntregas.metricasTempo?.tempoEsperaMinutos)}}</strong>
          </div>
          <div>
            <span>Entrega</span>
            <strong>{{formateMinutos(desempenhoEntregas.metricasTempo?.tempoEntregaMinutos)}}</strong>
          </div>
          <div>
            <span>Atraso médio</span>
            <strong>{{formateMinutos(desempenhoEntregas.prazos?.atrasoMedioMinutos)}}</strong>
          </div>
          <div>
            <span>Maior atraso</span>
            <strong>{{formateMinutos(desempenhoEntregas.prazos?.maiorAtrasoMinutos)}}</strong>
          </div>
        </div>

        <div class="painel-mapa-pedidos" [ngClass]="{'painel-mapa-compacto': !obtenhaTemPontosMapa()}">
          <div class="painel-mapa-cabecalho">
            <div class="painel-mapa-info">
              <h5>Mapa das entregas</h5>
              <span>
                {{desempenhoEntregas.localizacao?.registrada || 0}} registrada(s) ·
                {{obtenhaTotalLocalizacaoAproximada()}} aproximada(s)
              </span>
            </div>
            <button type="button"
                    class="acao-agrupar-entregas"
                    [ngClass]="{'ativo': agruparEntregasProximas}"
                    *ngIf="obtenhaEntregasMapa().length > 1"
                    [title]="agruparEntregasProximas ? 'Mostrar entregas individualmente' : 'Agrupar entregas próximas'"
                    (click)="alterneAgrupamentoEntregasProximas()">
              <i class="fe-layers"></i>
              <span>{{agruparEntregasProximas ? 'Agrupadas' : 'Agrupar próximas'}}</span>
            </button>
          </div>
          <div class="mapa-pedidos" *ngIf="obtenhaTemPontosMapa()">
            <div id="mapa-analise-pedidos" class="mapa-google-pedidos"></div>
            <div class="mapa-vazio" *ngIf="erroMapaAnaliseEntregas">
              {{erroMapaAnaliseEntregas}}
            </div>
          </div>

          <div class="mapa-compacto" *ngIf="!obtenhaTemPontosMapa()">
            <strong>Nenhuma localização para exibir no mapa</strong>
            <span>Os pedidos deste período continuam aparecendo nos resumos por bairro, origem e últimos pedidos.</span>
          </div>

          <div class="legenda-mapa" *ngIf="obtenhaTemPontosMapa()">
            <span><i class="legenda registrada"></i> Pedido com localização registrada</span>
            <span><i class="legenda aproximada"></i> Pedido aproximado</span>
            <span><i class="legenda bairro"></i> Bairro aproximado</span>
            <span><i class="legenda fora-area"></i> Tentativa fora da área</span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-4">
            <div class="tabela-analise">
              <h5>Origem dos pedidos</h5>
              <table class="table table-sm mb-0">
                <thead>
                <tr>
                  <th>Origem</th>
                  <th class="text-right">Pedidos</th>
                  <th class="text-right">Com localização</th>
                  <th class="text-right">Sem localização</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let origem of desempenhoEntregas.resumoPorOrigem">
                  <td>{{origem.origem}}</td>
                  <td class="text-right">{{origem.pedidos}}</td>
                  <td class="text-right">{{origem.comLocalizacao}}</td>
                  <td class="text-right">{{origem.semLocalizacao}}</td>
                </tr>
                <tr *ngIf="!desempenhoEntregas.resumoPorOrigem || desempenhoEntregas.resumoPorOrigem.length === 0">
                  <td colspan="4" class="text-muted text-center">Nenhum pedido no período</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="tabela-analise">
              <h5>Resumo por bairro</h5>
              <table class="table table-sm mb-0">
                <thead>
                <tr>
                  <th>Bairro</th>
                  <th class="text-right">Pedidos</th>
                  <th class="text-right">Sem localização</th>
                  <th class="text-right">No prazo</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let bairro of desempenhoEntregas.resumoPorBairro">
                  <td>{{bairro.bairro}}</td>
                  <td class="text-right">{{bairro.entregas}}</td>
                  <td class="text-right">{{bairro.semLocalizacao}}</td>
                  <td class="text-right">{{bairro.noPrazo}}</td>
                </tr>
                <tr *ngIf="!desempenhoEntregas.resumoPorBairro || desempenhoEntregas.resumoPorBairro.length === 0">
                  <td colspan="4" class="text-muted text-center">Nenhum pedido no período</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="tabela-analise">
              <h5>Últimos pedidos</h5>
              <table class="table table-sm mb-0">
                <thead>
                <tr>
                  <th>Pedido</th>
                  <th>Origem</th>
                  <th>Prazo</th>
                  <th>Localização</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let pedido of obtenhaUltimasEntregas()">
                  <td>
                    <a *ngIf="pedido.guidPedido" routerLink="/admin/pedidos/detalhes/{{pedido.guidPedido}}">
                      #{{pedido.codigoPedido}}
                    </a>
                    <span *ngIf="!pedido.guidPedido">#{{pedido.codigoPedido}}</span>
                  </td>
                  <td>{{pedido.origemPedido}}</td>
                  <td>
                    <span class="badge badge-success" *ngIf="pedido.noPrazo === true">No prazo</span>
                    <span class="badge badge-danger" *ngIf="pedido.noPrazo === false">Atrasado</span>
                    <span class="badge badge-light" *ngIf="pedido.noPrazo === null">Sem base</span>
                  </td>
                  <td>{{obtenhaDescricaoLocalizacao(pedido)}}</td>
                </tr>
                <tr *ngIf="!desempenhoEntregas.pedidos || desempenhoEntregas.pedidos.length === 0">
                  <td colspan="4" class="text-muted text-center">Nenhum pedido no período</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
